import { tween, styler } from 'popmotion';

export function animateOldContainer(oldContainer) {
    return new Promise((resolve) => {

        tween({ from: 1, to: 0, duration: 300 })
            .start({
                update: styler(oldContainer).set('opacity'),
                complete: resolve,
            });

    });
}

export function animateNewContainer(newContainer) {
    return new Promise((resolve) => {

        tween({ from: 0, to: 1, duration: 300 })
            .start({
                update: styler(newContainer).set('opacity'),
                complete: resolve,
            });
    });
}
